"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicEmailDomains = void 0;
exports.emailParse = emailParse;
const object_1 = require("./object");
function emailParse(email) {
    const [, domain] = email.match(/^[^\s@]+@([^\s@.]+\.[^\s@.]+)$/) || [];
    return (0, object_1.removeUndefined)({ full: email, domain });
}
// https://email-verify.my-addr.com/list-of-most-popular-email-domains.php
exports.publicEmailDomains = [
    'aol.com',
    'fastmail.com',
    'gmail.com',
    'hotmail.co.uk',
    'hotmail.com',
    'hotmail.fr',
    'icloud.com',
    'mail.ru',
    'mail.com',
    'msn.com',
    'orange.fr',
    'outlook.com',
    'outlook.fr',
    'protonmail.com',
    'wanadoo.fr',
    'yahoo.com',
    'yahoo.fr',
    'yandex.com',
    'yandex.ru',
    'zoho.com',
];
//# sourceMappingURL=email.js.map